let language = {
    "FILE_PREVIEW_MODAL_SUCCESS_TITLE":"成功",
    "FILE_PREVIEW_MODAL_FAILED_TITLE":"失败",
    "FILE_PREVIEW_MODAL_COPY_SUCCESS_TEXT":"复制成功!",
    "FILE_PREVIEW_MODAL_MOVE_SUCCESS_TEXT":"移动成功!",
    "FILE_PREVIEW_MODAL_MOVE_FAILED_TEXT":"移动失败!"
};

export { language }